export default "__VITE_PUBLIC_ASSET__3b3212ee__"